import React from "react";
import { useHistory } from "react-router-dom";

const DownloadButton = (props) => {
  const { file, fileName } = props;
  const history = useHistory();
  const handleFileOpen = () => {
    if (!file) return;

    if (file instanceof File || file instanceof Blob) {
      const fileUrl = URL.createObjectURL(file);
      window.open(fileUrl, "_blank");
    } else if (typeof file === "string") {
      window.open(file, "_blank");
    }
  };
  return (
    <>
      <button
        className="btn btn-primary"
        style={{
          fontSize: "13px",
          // color: "rgb(254, 254, 254)",
          // backgroundColor: "rgb(33, 150, 243)",
          backgroundColor: "rgb(255,255,255)",
          color: "rgb(0,0,0)",
          // paddingTop: "3px",
          // paddingBottom: "4px",
          // marginTop: "2px",
          // marginBottom: "5px",
          // paddingRight: "2px",
          // paddingLeft: "1px",
          // width: "85px",
          // borderRadius: "4px",
          // fontFamily: "emoji",
          // fontWeight: "700",
        }}
        onClick={handleFileOpen}
      >
        <i class="bi bi-download me-1"></i>
        Download
      </button>
    </>
  );
};

export default DownloadButton;
